import React, { useMemo, useState } from 'react';
import { Box, Link } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import { isEmpty } from 'lodash';

import { LinkItem } from './LinkItem/LinkItem';

export const ExpandableLinkList = ({ data, type = 'file' }) => {
  const MAX_ROW_LENGTH = 4;

  if (isEmpty(data)) {
    return '—';
  }

  return data.length > MAX_ROW_LENGTH ? (
    <ExpandableList data={data} type={type} visibleLinksCount={MAX_ROW_LENGTH} />
  ) : (
    <FullList data={data} type={type} />
  );
};

const FullList = ({ data, type }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      {data.map(item => (
        <LinkItem item={item} type={type} key={type === 'file' ? item.uniqueIdentifier : item.taskId} />
      ))}
    </Box>
  );
};

const ExpandableList = ({ data, type, visibleLinksCount }) => {
  const apiRef = useGridApiContext();
  const [expanded, setExpanded] = useState(false);

  const visibleItems = useMemo(() => (expanded ? data : data?.slice(0, visibleLinksCount - 1)), [
    data,
    expanded,
    visibleLinksCount
  ]);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      {visibleItems?.map(item => (
        <LinkItem item={item} type={type} key={type === 'file' ? item.uniqueIdentifier : item.taskId} />
      ))}
      <Link
        component="button"
        onClick={() => {
          setExpanded(!expanded);
          apiRef?.current?.resetRowHeights();
        }}
        sx={{
          width: 'fit-content',
          fontSize: 'inherit',
          letterSpacing: 'inherit'
        }}
      >
        {expanded ? 'view less' : 'view more'}
      </Link>
    </Box>
  );
};
